const News = ({ data, id }) => {
    return (
        <section
            id={id}
            className="py-12 sm:py-14 md:py-16 mt-6 sm:mt-8 md:mt-10 lg:mt-20 xl:mt-24 pb-20 sm:pb-24 lg:pb-32 xl:pb-40"
        >
            <div className="w-full px-4 lg:w-[70%] lg:max-w-[1440px] mx-auto md:text-center">
                <div className="max-w-5xl space-y-3 md:mx-auto">
                    <h3 className="text-gray-800 font-semibold text-3xl sm:text-4xl xl:text-4xl">
                        {data.title}
                    </h3>
                </div>

                <div className="mt-6 sm:mt-8 lg:mt-16 xl:mt-16 overflow-x-auto">
                    <div className="grid grid-cols-5 gap-2 sm:gap-4 md:gap-6 w-full min-w-[720px]">
                        {data.items.map((item, idx) => (
                            <div
                                key={idx}
                                className="border border-gray-300 rounded-md flex items-center justify-center 
                   w-full h-[60px] sm:h-[80px] md:h-[90px] lg:h-[100px] px-2"
                            >
                                <img
                                    src={item.img}
                                    alt=""
                                    className="max-h-[80%] max-w-[80%] object-contain"
                                />
                            </div>
                        ))}
                    </div>
                </div>


            </div>
        </section>
    );
};

export default News;
